export default __webpack_public_path__ + "6103056522b0e3160947b72e9bbc4970.jpg";